import type { KambiListView } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventsForCompetition(
  sport: string,
  region: string,
  competition: string,
  categoryId?: number,
  includeParticipants = true
) {
  let query = `?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true&includeParticipants=${includeParticipants}`
  if (categoryId) {
    query = query + `&category=${categoryId}`
  }

  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${competition}/all/matches${query}`
  )
}

export function getFuturesEventsForCompetition(sport: string, region: string, league: string) {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${league}/all/competitions.json?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true`
  )
}

export function getSearchResult(searchPath: string) {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView${searchPath}?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true`
  )
}

export function getEventsBySportTermKey(sport: string, categoryId?: number) {
  let query = 'lang=en_AU&market=AU&includeParticipants=true'
  if (categoryId) {
    query = query + `&category=${categoryId}`
  }

  return simpleFetch<KambiListView>(`${window._kc.apiOfferingBaseUrl}listView/${sport}?${query}`)
}
